import isExportFormatForNumber from './isExportFormatForNumber';

import * as rowTypes from '../constants/rowTypes'; // eslint-disable-line import/no-namespace

const isRowNumberType = row => {
  const { rowType } = row;

  if (!rowType) {
    return false;
  }

  const rowTypeIsText
    = rowType === rowTypes.TEXT
    || rowType === rowTypes.SECTION_HEADER
    || rowType === rowTypes.COLUMN_HEADER
    || rowType === rowTypes.EMPTY;

  if (rowTypeIsText) {
    return false;
  }

  const rowHasExportFormat = row.format;

  if (!rowHasExportFormat) {
    return true;
  }

  return isExportFormatForNumber(row.format);
};

export default isRowNumberType;
